module.exports = {"150624100":"乌兰镇","150624101":"棋盘井镇","150624102":"蒙西镇","150624103":"木凯淖尔镇","150624200":"苏米图苏木","150624201":"阿尔巴斯苏木","150624404":"内蒙古鄂托克经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150624.json
// module id = 529
// module chunks = 0